import { motion } from "framer-motion";
import React, { useContext, useState } from "react";
import VisibilitySensor from "react-visibility-sensor";
import { Context } from "../../context";
import Spacer from "../Utils/Spacer";
import TitleHome from "../Utils/TitleHome";
import classes from "./About.module.css";

import { PlanetSVG, RocketSVG, StarsSVG, UfoSVG, ConstellationSVG } from "./AmbitionSVGs";

const AmbitionsHome = () => {
  const [demoData, setDemoData] = useState([]);
  const { debug, lang } = useContext(Context);

  const [isVisible, setIsVisible] = useState(false);

  const changeVisibility = (isVisibleSensor) => {
    if (isVisibleSensor && isVisible === false) {
      setIsVisible(true);
    }
  };

  return (
    <>
      <section
        id="ambitionsHome"
        className={classes.bgAmbitions + " section p_zero position-relative"}
      >
        {/* Decorative SVGs */}
        <motion.div
          animate={{ y: [0, -20, 0], rotate: [0, 5, 0] }}
          transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
          style={{ position: 'absolute', top: '10%', left: '5%', width: '150px', zIndex: 0, pointerEvents: 'none' }}
        >
          <PlanetSVG />
        </motion.div>

        <motion.div
          animate={{ y: [0, 15, 0], opacity: [0.6, 1, 0.6] }}
          transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
          style={{ position: 'absolute', bottom: '15%', left: '40%', width: '100px', zIndex: 0, pointerEvents: 'none' }}
        >
          <StarsSVG />
        </motion.div>

        <motion.div
          animate={{ y: [0, -20, 0], x: [0, -10, 0] }}
          transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
          style={{ position: 'absolute', bottom: '20%', right: '5%', width: '60px', zIndex: 0, pointerEvents: 'none', opacity: 1 }}
        >
          <RocketSVG style={{ transform: 'rotate(-45deg)' }} />
        </motion.div>



        <div className="text-left py-5 position-relative" style={{ zIndex: 10 }}>
          <div className="container row m-auto">
            <div className="col-md-5" style={{ textAlign: "left" }}>

              <VisibilitySensor
                onChange={changeVisibility}
                partialVisibility
                delayedCall
              >
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{
                    opacity: isVisible ? 1 : 0,
                    y: isVisible ? 0 : 20,
                  }}
                  transition={{ duration: 0.6, delay: 0.5 }}
                  className={classes.ambitionBox} // New Glass Card
                >

                  <div className={classes.devPreTitle} style={{ marginBottom: '10px' }}>
                    <span className={classes.devPrompt}>$</span>
                    <span className={classes.devCmd}>./ambitions.sh</span>
                    <span className={classes.devCursor} />
                  </div>

                  {lang === "en" && (
                    <div className="text-white display-6 bold" style={{ fontWeight: 'bold', fontSize: '2.2rem', display: 'block', marginBottom: '16px' }}>Ambitions</div>
                  )}
                  {lang === "it" && (
                    <div className="text-white display-6 bold" style={{ fontWeight: 'bold', fontSize: '2.2rem', display: 'block', marginBottom: '16px' }}>Ambizione</div>
                  )}

                  <p className="text-4 text-white w-100 mb-0 mt-3">
                    {lang === "en" && (
                      <>
                        My ambition is to continue working in the IT sector,
                        where I can express my <span className={classes.highlightText}>creativity</span> and apply my skills to
                        important and challenging projects. I aim to work with{" "}
                        <span className={classes.highlightText}>MERN</span> or <span className={classes.highlightText}>LAMP</span> stacks, complex architectures, and
                        powerful, secure <span className={classes.highlightText}>microservices</span>. Above all{" "}
                        <b>never stop learning</b>.
                      </>
                    )}
                    {lang === "it" && (
                      <>
                        La mia ambizione è continuare a lavorare nel settore IT,
                        dove posso esprimere la mia <span className={classes.highlightText}>creatività</span> e applicare le
                        mie competenze su progetti importanti e stimolanti.
                        Voglio lavorare con stack <span className={classes.highlightText}>MERN</span> o <span className={classes.highlightText}>LAMP</span>, architetture
                        complesse, software a <span className={classes.highlightText}>microservizi</span> potenti e sicuri. Ma
                        soprattutto <b>non smettere mai di imparare</b>.
                      </>
                    )}
                  </p>
                </motion.div>
              </VisibilitySensor>

              <Spacer height="170" />

            </div>
            <div className="col-md-7">
              <iframe
                src="https://rocket.davidebalice.dev/"
                title="rocket"
                className={classes.rocketFrame}
              />
            </div>
          </div>
        </div>

        <Spacer height="20" />
      </section>
    </>
  );
};

export default AmbitionsHome;
